export function LicenseType({
    uid,
    name,
    typeFunctionality,
    typeDuration,
    duration,
    numRemainingLicenses,
    numAssignedLicenses,
    numTotaLicenses,
    isDemo,
    isEnabled,
} = {}) {
    return {
        uid,
        name,
        typeFunctionality,
        typeDuration,
        duration,
        numRemainingLicenses,
        numAssignedLicenses,
        numTotaLicenses,
        isDemo,
        isEnabled,
    };
}
